import { render, staticRenderFns } from "./LessonChatHistoryViewerComponent.vue?vue&type=template&id=be25f2cc&scoped=true&"
import script from "./LessonChatHistoryViewerComponent.vue?vue&type=script&lang=js&"
export * from "./LessonChatHistoryViewerComponent.vue?vue&type=script&lang=js&"
import style0 from "./LessonChatHistoryViewerComponent.vue?vue&type=style&index=0&id=be25f2cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be25f2cc",
  null
  
)

export default component.exports